import { render, staticRenderFns } from "./AdminOperation.vue?vue&type=template&id=c935d3bc&scoped=true&"
import script from "./AdminOperation.vue?vue&type=script&lang=ts&"
export * from "./AdminOperation.vue?vue&type=script&lang=ts&"
import style0 from "./AdminOperation.vue?vue&type=style&index=0&id=c935d3bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c935d3bc",
  null
  
)

export default component.exports